import * as React from 'react';
import ReactDOM from 'react-dom';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import TextField from '@mui/material/TextField';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import RefreshIcon from '@mui/icons-material/Refresh';

// my imports
import { Autocomplete } from '@mui/material';
import { Auth, API } from 'aws-amplify';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import PauseCircleFilledIcon from '@mui/icons-material/PauseCircleFilled';

import titles from '../titles.json';
import VideoEngineShaka from '../videoEngineShaka.js';

import { useEffect } from 'react';

import { Radio, RadioGroup } from '@mui/material';

import FormControlLabel from '@mui/material/FormControlLabel';
import Box from '@mui/material/Box';

// date picker (desktop) + native input (mobile)
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DesktopDateTimePicker } from '@mui/x-date-pickers/DesktopDateTimePicker';
import dayjs from 'dayjs';

import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';

import config from '../config.js';

import Modal from '@mui/material/Modal';

import PaymentMethods from '../stripe/PaymentMethods.js';
// Make sure to call `loadStripe` outside of a component’s render to avoid
// recreating the `Stripe` object on every render.
import { loadStripe } from '@stripe/stripe-js';

const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

const childModalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  pt: 2,
  px: 4,
  pb: 3,
};

// Each recording is 40 minutes long.
const RECORDING_MINUTES = 40;

export default function Cameras(props) {
  const [searchedClubSelection, setClubSelection] = React.useState('');
  const [clubListApproved, setClubListApproved] = React.useState(undefined);
  const [cameraList, setCameraList] = React.useState([]);
  const [selectedCamera, setSelectedCamera] = React.useState(undefined);

  // can add async events in useEffects for APIs
  const [loading, setLoading] = React.useState(false);

  const [streamPlaybacks, setStreamPlaybacks] = React.useState(undefined);
  const [potentialDayCollisions, setPotentialDayCollisions] = React.useState(undefined);
  const [collision, setCollision] = React.useState(true);
  const [startDateTime, setStartDateTime] = React.useState('');

  const [openSubscriptionModal, setSubscriptionModaleOpen] = React.useState(false);
  const handleSubscriptionModalClose = () => setSubscriptionModaleOpen(false);
  const [openOneTimeModal, setOneTimeModaleOpen] = React.useState(false);
  const [openFreeOneTimeModal, setFreeOneTimeModaleOpen] = React.useState(false);
  const handleOneTimeModalClose = () => setOneTimeModaleOpen(false);
  const handleFreeOneTimeModalClose = () => setFreeOneTimeModaleOpen(false);
  const [displayPaymentMethodsView, setDisplayPaymentMethodsView] = React.useState(false);
  const [clientSecret, setClientSecret] = React.useState('');
  const [stripePromise, setStripePromise] = React.useState(null);

  // Mobile detection: we use native datetime-local on mobile for best UX
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const now = new Date();

  const floorToMinute = (d) => new Date(Math.floor(d.getTime() / 60000) * 60000);

  const maximumStartDate = now.setDate(
    now.getDate() + config.getEnvironmentConfig('production').maxDatePlayBack
  );

  useEffect(() => {
    setStripePromise(loadStripe(config.getEnvironmentConfig(config.Environment).stripePublishableKey));

    if (loading) {
      return undefined;
    }
    setLoading(true);

    (async () => {
      let fullClubList = await getClubList();
      var list = [];
      let i = 0;
      var sub = props.sub;
      while (i < fullClubList.length) {
        var memberState = stateOfMembership({ id: fullClubList[i].clubId, label: fullClubList[i].clubName });
        if (memberState === 'approved') {
          var newItem = {
            cameras: fullClubList[i].cameras,
            clubId: fullClubList[i].clubId,
            clubName: fullClubList[i].clubName,
            address: fullClubList[i].address,
            phone: fullClubList[i].phone,
            isMember: memberState,
          };
          list.push(newItem);
        }
        i++;
      }
      setClubListApproved(list);
    })();

    return () => {
      let a = null;
    };
  }, [loading], [props]);

  const getClubList = async (event) => {
    try {
      var path = `clubs?key1=na`;
      let clubData = await API.get('clubs', path);

      if (!!clubData) {
        return clubData;
      } else {
        console.log('clubData came back empty');
      }
    } catch (e) {
      console.log('clubData error is: ', e);
      alert(e.message);
    }
  };

  const getStreamList = async (cloudStreamName) => {
    try {
      var path = `videos?type=streamList&streamName=${cloudStreamName}&range=all`;
      let playbacks = await API.get('videos', path);

      if (!!playbacks) {
        setStreamPlaybacks(playbacks);
        return playbacks;
      } else {
        console.log('playbacks came back empty');
      }
    } catch (e) {
      console.log('playbacks error is: ', e);
      alert(e.message);
    }
  };

  const handleClubSearchTextFieldChange = (clubInfo) => {
    setClubSelection(clubInfo.label);
    let i = 0;
    var found = false;
    while (i < clubListApproved.length && !found) {
      var id = clubListApproved[i].clubId;
      if (id === clubInfo.id) {
        found = true;
        setCameraList(clubListApproved[i].cameras);
      }
      i++;
    }
    if (!found) {
      setCameraList([]);
    }
  };

  const makeClubsDropDownFromClubsData = (clubData) => {
    let i = 0;
    var dropDown = [];
    while (i < clubData.length) {
      var id = clubData[i].clubId;
      var label = clubData[i].clubName;
      var newItem = { id: id, label: label };
      dropDown.push(newItem);
      i++;
    }
    return dropDown;
  };

const scheduleRecording = async () => {
  try {
    const promo = props?.userData?.promo; // could be undefined/null/string
    const stripe = props?.userData?.stripe;

    const isFreePromo = promo === "free";
    const isSubscribed =
      stripe?.subscription !== undefined && stripe?.subscription !== null;

    // Guards for required scheduling inputs
    if (!selectedCamera?.streamName || !selectedCamera?.name) {
      alert("No camera selected.");
      return;
    }
    if (!startDateTime) {
      alert("Missing start date/time.");
      return;
    }

    // Access control: only free promo bypasses subscription requirement
    if (!isFreePromo && !isSubscribed) {
      alert("Only subscribing members can schedule playbacks");
      return;
    }

    // customerId requirement: only required when NOT free promo
    const customerId = stripe?.customerId;
    if (!isFreePromo && !customerId) {
      alert("Missing customer id.");
      return;
    }

    // Build query params
    const params = new URLSearchParams({
      startDateTime: String(startDateTime),
      streamName: String(selectedCamera.streamName),
      type: "storePlayback",
      cameraName: String(selectedCamera.name),
    });

    // Only include customerId if present (free promo may be empty/undefined)
    if (customerId) params.set("customerId", String(customerId));

    // Only include promo flag if it's actually free
    if (isFreePromo) params.set("promo", "free");

    const path = `videos?${params.toString()}`;

    console.log(
      isFreePromo
        ? "free promo recording being sent to backend with promo=free flag"
        : "regular recording being sent to backend"
    );

    const response = await API.post("videos", path);

    if (response) {
      alert("It's been scheduled");

      // refresh list so collision checks include the new recording
      await getStreamList(selectedCamera.streamName);

      // clear any old collision UI state
      setCollision(false);
    } else {
      alert("Failed to schedule recording.");
    }
  } catch (e) {
    console.log("response error is: ", e);
    alert(e?.message ?? "Failed to schedule recording.");
  }
};


  const stateOfMembership = (clubInfo) => {
    var result = '';
    let i = 0;
    while (i < props.userData.clubs.approved.length) {
      if (props.userData.clubs.approved[i] === clubInfo.id) {
        result = 'approved';
      }
      i++;
    }
    i = 0;
    while (i < props.userData.clubs.pending.length) {
      if (props.userData.clubs.pending[i] === clubInfo.id) {
        result = 'pending';
      }
      i++;
    }
    return result;
  };

  const switchCamera = ({ event, name }) => {
  const isSubscribed = props?.userData?.stripe?.subscription != null;
  const isFreePromo = props?.userData?.promo === 'free';

  if (isSubscribed || isFreePromo) {
    const streamName = event.target.value;
    const cam = { streamName, name };
    getStreamList(streamName);
    setSelectedCamera(cam);
  } else {
    setSubscriptionModaleOpen(true);
  }
};

  /**
   * Business rule: user may only select a start time >= getMinDateTime() (not just "now")
   * and <= maximumStartDate.
   *
   * This function:
   * - normalizes inputs from BOTH DesktopDateTimePicker (dayjs) and native datetime-local (string)
   * - clamps the value into [min,max] so mobile can't "type" or "scroll" into invalid past times
   * - updates startDateTime reliably (fixes mobile “tap time/day doesn’t set” issues by keeping a controlled value)
   * - computes overlaps and fills potentialDayCollisions with the *actual conflicting recordings*
   */
// Put this helper somewhere above setRecordingTime (inside the component):
// const floorToMinute = (d) => new Date(Math.floor(d.getTime() / 60000) * 60000);

const setRecordingTime = (e) => {
  const raw = e?.event;
  if (!raw) return;

  // Normalize to dayjs, preserving local interpretation for native input (important for mobile/Safari)
  let selected = null;
  if (dayjs.isDayjs(raw)) {
    selected = raw;
  } else if (raw instanceof Date) {
    selected = dayjs(raw);
  } else if (typeof raw === 'string') {
    // native datetime-local returns "YYYY-MM-DDTHH:mm" (no timezone). dayjs parses as local.
    selected = dayjs(raw);
  } else {
    selected = dayjs(raw);
  }

  if (!selected || !selected.isValid()) return;

  const min = getMinDateTime();
  const max = dayjs(maximumStartDate);

  // Clamp selection into [min,max]
  if (selected.isBefore(min)) selected = min;
  if (selected.isAfter(max)) selected = max;

  // Normalize selection to minute precision
  const selectedStart = floorToMinute(selected.toDate());
  const selectedEnd = new Date(selectedStart.getTime() + RECORDING_MINUTES * 60 * 1000);

  // Always set state so controlled inputs reflect the user's interaction (mobile fix)
  setStartDateTime(selectedStart.toISOString());

  // streamPlaybacks might still be undefined until a camera is selected
  if (!Array.isArray(streamPlaybacks)) {
    setCollision(true);
    setPotentialDayCollisions([]);
    return;
  }

  const collisions = [];
  for (let i = 0; i < streamPlaybacks.length; i++) {
    const pb = streamPlaybacks[i];
    if (!pb?.startDateTime) continue;

    // Normalize existing start/end to minute precision too
    const existingStartRaw = new Date(pb.startDateTime);
    if (Number.isNaN(existingStartRaw.getTime())) continue;

    const existingStart = floorToMinute(existingStartRaw);

    // Some APIs might include endDateTime; if not, we assume 40 minutes like your original logic.
    const existingEndRaw = pb.endDateTime
      ? new Date(pb.endDateTime)
      : new Date(existingStartRaw.getTime() + RECORDING_MINUTES * 60 * 1000);

    if (Number.isNaN(existingEndRaw.getTime())) continue;

    const existingEnd = floorToMinute(existingEndRaw);

    // Overlap rule (half-open intervals): newStart < existingEnd && newEnd > existingStart
    // This ALLOWS back-to-back: selectedStart === existingEnd => not overlapping.
    const overlaps = selectedStart < existingEnd && selectedEnd > existingStart;
    if (overlaps) collisions.push(pb);
  }

  setCollision(collisions.length > 0);
  setPotentialDayCollisions(collisions);
};


  const diff_minutes = (dt2, dt1) => {
    var diff = (dt2.getTime() - dt1.getTime()) / 1000;
    diff /= 60;
    return Math.abs(Math.round(diff));
  };

  const showPaymentMethodsView = async () => {
    try {
      var path;
      path = `payments?type=setupIntent`;
      let response = await API.post('payments', path);
      if (!!response) {
        if (response.client_secret !== '') {
          setClientSecret(response.client_secret);
          setDisplayPaymentMethodsView(true);
        }
      }
    } catch (e) {
      console.log('response error is: ', e);
      alert(e.message);
    }
  };

  function PaymentDetailsModal() {
    const [open, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    return (
      <React.Fragment>
        <Button onClick={handleOpen}>Subscription Fees</Button>
        <Modal open={open} onClose={handleClose} aria-labelledby="child-modal-title" aria-describedby="child-modal-description">
          <Box sx={{ ...childModalStyle, width: 400 }}>
            <h2 id="child-modal-title">Fees</h2>
            <p id="child-modal-description">
              We charge ${config.getEnvironmentConfig('production').subscriptionFee} per month. Your first monthly charge will be today. Each camera
              reservation costs ${config.getEnvironmentConfig('production').playbackFee} charged one time when the recording time begins.
            </p>
            <Button onClick={handleClose}>Close</Button>
          </Box>
        </Modal>
      </React.Fragment>
    );
  }

  const releaseModalFromCCView = () => {
    handleSubscriptionModalClose();
    setDisplayPaymentMethodsView(false);
  };

  const getMinDateTime = () => {
    const mins = config.getEnvironmentConfig('production').minFutureTime;
    const t = dayjs().add(mins, 'minute').toDate();
    return dayjs(floorToMinute(t)); // <-- round DOWN to what the UI shows
  };


  const formatForDateTimeLocal = (d) => dayjs(d).format('YYYY-MM-DDTHH:mm');

  const getNativeValueFromState = () => {
    if (!startDateTime) return '';
    // Convert stored ISO -> local string for datetime-local
    return formatForDateTimeLocal(dayjs(startDateTime));
  };

  // For DesktopDateTimePicker: controlled value
  const getDesktopValueFromState = () => {
    if (!startDateTime) return null;
    const v = dayjs(startDateTime);
    return v.isValid() ? v : null;
  };

  return (
    <Paper sx={{ maxWidth: 936, margin: 'auto', overflow: 'visible' }}>
      <AppBar position="static" color="default" elevation={3} sx={{ borderBottom: '1px solid rgba(0, 0, 0, 0.12)' }}>
        <Box component="main" sx={{ p: 3 }}>
          {props.topNavSelectedId === titles.app.services.topNavigatorTabs.cameras[0] ? (
            <Grid container spacing={2} alignItems="center">
              <Grid item>
                <SearchIcon color="inherit" sx={{ display: 'block' }} />
              </Grid>
              <Grid item xs>
                {clubListApproved !== undefined ? (
                  <Autocomplete
                    disablePortal
                    disableClearable
                    id="club-selection"
                    options={makeClubsDropDownFromClubsData(clubListApproved)}
                    onChange={(event, value) => handleClubSearchTextFieldChange(value)}
                    renderInput={(params) => <TextField variant="standard" fullWidth {...params} label="Club Name" />}
                  />
                ) : (
                  <Typography>...</Typography>
                )}
              </Grid>
            </Grid>
          ) : null}
        </Box>

        {cameraList.length > 0 ? (
          <Toolbar>
            <Modal open={openSubscriptionModal} onClose={handleSubscriptionModalClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
              <Box sx={modalStyle}>
                {displayPaymentMethodsView ? (
                  <div>
                    {clientSecret && stripePromise && (
                      <PaymentMethods secret={clientSecret} stripePromise={stripePromise} releaseModalFromCCView={() => releaseModalFromCCView()} />
                    )}
                    <button
                      variant="primary"
                      onClick={() => {
                        handleSubscriptionModalClose();
                        setDisplayPaymentMethodsView(false);
                      }}
                    >
                      Cancel
                    </button>
                  </div>
                ) : (
                  <div>
                    <Typography id="modal-modal-title" variant="h6" component="h2">
                      Subscription Required
                    </Typography>
                    <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                      To schedule a recording, you must be subscribed to the GameTimePlayback service. Would you like to subscribe?
                      <PaymentDetailsModal />
                    </Typography>
                    <ButtonGroup variant="text" aria-label="Basic button group">
                      <Button onClick={() => showPaymentMethodsView()}>Yes</Button>
                      <Button onClick={() => handleSubscriptionModalClose()}>Later</Button>
                    </ButtonGroup>
                  </div>
                )}
              </Box>
            </Modal>

            <Modal open={openOneTimeModal} onClose={handleOneTimeModalClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
              <Box sx={modalStyle}>
                <div>
                  <Typography id="modal-modal-title" variant="h6" component="h2">
                    Notice of payment
                  </Typography>
                  <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                    A one time payment of $4 will be charged later when the scheduled recording starts. You can cancel the recording without incurring charges up
                    to 10 minutes before start time. Would you like to proceed?
                  </Typography>
                  <ButtonGroup variant="text" aria-label="Basic button group">
                    <Button
                      onClick={() => {
                        handleOneTimeModalClose();
                        scheduleRecording();
                      }}
                    >
                      Yes
                    </Button>
                    <Button
                      onClick={() => {
                        setSelectedCamera(undefined);
                        handleOneTimeModalClose();
                        setCollision(true);
                      }}
                    >
                      No
                    </Button>
                  </ButtonGroup>
                </div>
              </Box>
            </Modal>
            <Modal open={openFreeOneTimeModal} onClose={handleFreeOneTimeModalClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
              <Box sx={modalStyle}>
                <div>
                  <Typography id="modal-modal-title" variant="h6" component="h2">
                    Free Trial Playback
                  </Typography>
                  <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                    Your account is currently in a free trial period which allows for free recordings. Click yes to continue or no to cancel.
                  </Typography>
                  <ButtonGroup variant="text" aria-label="Basic button group">
                    <Button
                      onClick={() => {
                        handleFreeOneTimeModalClose();
                        scheduleRecording();
                      }}
                    >
                      Yes
                    </Button>
                    <Button
                      onClick={() => {
                        setSelectedCamera(undefined);
                        handleFreeOneTimeModalClose();
                        setCollision(true);
                      }}
                    >
                      No
                    </Button>
                  </ButtonGroup>
                </div>
              </Box>
            </Modal>

            <Grid container spacing={2} m={1}>
              {selectedCamera !== undefined ? (
                <Grid item xs={12}>
                  <Typography variant="caption" display="block">
                    Selected: {selectedCamera.name}
                  </Typography>

                  {startDateTime !== '' ? (
                    <Typography variant="caption" display="block">
                      Starting at: &nbsp;
                      {new Date(startDateTime).toLocaleDateString('en-us', {
                        weekday: 'long',
                        year: 'numeric',
                        month: 'short',
                        day: 'numeric',
                        hour: '2-digit',
                        minute: '2-digit',
                        hour12: true,
                      })}
                    </Typography>
                  ) : null}

                  <Box sx={{ mt: 0.5 }}>
                    {collision === false && startDateTime !== '' ? (
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
                        <Typography variant="caption" display="block">
                          Availability
                        </Typography>
                        <CheckCircleOutlineIcon color={'success'} />
                      </Box>
                    ) : null}
                  </Box>
                </Grid>
              ) : null}

              {/* Important: use full width on mobile so label content doesn't get squeezed/clipped */}
              <Grid item xs={12} sm={6}>
                <RadioGroup aria-labelledby="demo-radio-buttons-group-label" defaultValue="female" name="radio-buttons-group">
                  {cameraList.map(({ name, streamName }) => (
                    <FormControlLabel
                      key={streamName}
                      value={streamName}
                      control={<Radio onChange={(e) => switchCamera({ event: e, name: name })} />}
                      label={
                        <Box sx={{ width: '100%' }}>
                          <Typography style={{ wordWrap: 'break-word' }}>Camera: {name}</Typography>

                          {selectedCamera != undefined && selectedCamera.name === name ? (
                            <Box sx={{ mt: 1, width: '100%' }}>
                              {isMobile ? (
                                <TextField
                                  fullWidth
                                  label="Pick date & time"
                                  type="datetime-local"
                                  value={getNativeValueFromState()}
                                  onChange={(e) => setRecordingTime({ event: e.target.value })}
                                  onBlur={(e) => {
                                    // Extra guard: if user manually edits, re-normalize/clamp on blur
                                    if (e?.target?.value) setRecordingTime({ event: e.target.value });
                                  }}
                                  InputLabelProps={{ shrink: true }}
                                  inputProps={{
                                    step: 60,
                                    // IMPORTANT: native "min" alone isn't sufficient (users can type past values),
                                    // but we still set it to guide the picker UI.
                                    min: formatForDateTimeLocal(getMinDateTime()),
                                    max: formatForDateTimeLocal(dayjs(maximumStartDate)),
                                  }}
                                  error={collision === true && startDateTime !== ''}
                                  helperText={
                                    collision === true && startDateTime !== ''
                                      ? 'Conflicts with an existing recording'
                                      : `Must be at least ${config.getEnvironmentConfig('production').minFutureTime} min in the future`
                                  }
                                />
                              ) : (
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                  <DesktopDateTimePicker
                                    closeOnSelect={false}
                                    value={getDesktopValueFromState()}
                                    slotProps={{
                                      textField: {
                                        readOnly: false,
                                        fullWidth: true,
                                        error: collision === true && startDateTime !== '',
                                      },
                                    }}
                                    disablePast
                                    minutesStep={1}
                                    disableMaskedInput={true}
                                    minDateTime={getMinDateTime()}
                                    maxDate={dayjs(maximumStartDate)}
                                    onChange={(val) => setRecordingTime({ event: val })}
                                    label="Click calendar icon ->"
                                  />
                                </LocalizationProvider>
                              )}

                              {/* Conflicts list: shows the actual overlapping recording(s) */}
                              {Array.isArray(potentialDayCollisions) && potentialDayCollisions.length > 0 ? (
                                <Box sx={{ width: '100%', mt: 1, display: 'block' }}>
                                  <div>{!isMobile ? <Typography>In conflict with:</Typography> : null}</div>
                                  <Box sx={{ width: '100%' }}>
                                    {potentialDayCollisions.map((pb) => {
                                      const pbStart = pb?.startDateTime ? new Date(pb.startDateTime) : null;
                                      const pbEnd = pb?.endDateTime
                                        ? new Date(pb.endDateTime)
                                        : pbStart
                                          ? new Date(pbStart.getTime() + RECORDING_MINUTES * 60 * 1000)
                                          : null;

                                      const key = pb?.id || pb?.startDateTime || `${name}-${Math.random()}`;
                                      if (!pbStart || Number.isNaN(pbStart.getTime())) return null;

                                      return (
                                        <Box
                                          key={key}
                                          sx={{ border: 1, borderColor: 'error.main', m: 1, borderRadius: '4px', p: 1 }}
                                        >
                                          <Typography color={'error'}>
                                            {pbStart.toLocaleDateString('en-us', {
                                              month: 'short',
                                              day: 'numeric',
                                              hour: '2-digit',
                                              minute: '2-digit',
                                              hour12: true,
                                            })}
                                            {pbEnd && !Number.isNaN(pbEnd.getTime()) ? (
                                              <>
                                                {' '}
                                                –{' '}
                                                {pbEnd.toLocaleTimeString('en-us', {
                                                  hour: '2-digit',
                                                  minute: '2-digit',
                                                  hour12: true,
                                                })}
                                              </>
                                            ) : null}
                                          </Typography>
                                        </Box>
                                      );
                                    })}
                                  </Box>
                                </Box>
                              ) : null}
                            </Box>
                          ) : null}
                        </Box>
                      }
                      sx={{
                        alignItems: 'flex-start',
                        width: '100%',
                        m: 0,
                        '& .MuiFormControlLabel-label': { width: '100%' },
                      }}
                    />
                  ))}
                </RadioGroup>

                <Typography sx={{ my: 5, mx: 2 }} color="text.secondary" align="left">
                  {collision === false ? (
                    <Button color="warning" onClick={() => {
                        if (props.userData.promo === 'free') {
                          console.log('free');
                          setFreeOneTimeModaleOpen(true)
                        } else {
                          console.log('not free');
                          setOneTimeModaleOpen(true)
                        }
                      }}>
                      {titles.cameras.cameras.schedule}
                    </Button>
                  ) : null}
                </Typography>
              </Grid>
            </Grid>
          </Toolbar>
        ) : null}
      </AppBar>

      <Toolbar>
        {props.topNavSelectedId === titles.app.services.topNavigatorTabs.cameras[0] ? (
          <Typography sx={{ my: 5, mx: 2 }} color="text.secondary" align="center">
            {titles.cameras.cameras.general}
          </Typography>
        ) : null}
      </Toolbar>
    </Paper>
  );
}
